<div class="text-center">
	<h3>Are you sure you want to remove this mortgage?</h3>
	<p>This is a permanent action and cannot be undone</p>
	<div class="justify-between flex mt-4">
		<app-button btn="secondary" mat-dialog-close=""> Keep </app-button>

		<app-button btn="error" (click)="onDelete()">Delete</app-button>
	</div>
</div>
